import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "ya-resetbasketwarningdialog",
  templateUrl: "./resetbasketwarningdialog.component.html",
  styleUrls: ["./resetbasketwarningdialog.component.scss"]
})
export class ResetbasketwarningdialogComponent implements OnInit {

  constructor(public bottomSheetRef: MatBottomSheetRef<ResetbasketwarningdialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    , private _coreLanguageService: CoreLanguageService) { }

  ngOnInit() {
  }

  public setSubHeaderContent() {
    const me = this;
    return me._coreLanguageService.value("phResetBasketWarning_SubHeaderContent").replace("{locationName}", me.data.locationName);
  }

  public resetBasket() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public cancelChangeBasket() {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }

}
